import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, LoaderCircle, XCircle } from "lucide-react";
import { authApi } from "../../services/api";

export default function VerifyEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    let active = true;
    authApi.verifyEmail(token)
      .then(({ data }) => {
        if (!active) return;
        setStatus("success");
        setMessage(data.message || "Your email has been verified.");
      })
      .catch((err) => {
        if (!active) return;
        setStatus("error");
        setMessage(err.response?.data?.message || "This verification link is invalid or has expired.");
      });
    return () => { active = false; };
  }, [token]);

  const Icon = status === "loading" ? LoaderCircle : status === "success" ? CheckCircle2 : XCircle;

  return (
    <div className="auth-shell auth-shell-centered">
      <div className="auth-card auth-card-solo">
        <div className="auth-sent-state">
          <span className={`auth-sent-icon ${status === "error" ? "is-error" : ""}`}>
            <Icon className={status === "loading" ? "spin" : ""} size={32} />
          </span>
          <h1>{status === "loading" ? "Verifying email" : status === "success" ? "Email verified" : "Verification failed"}</h1>
          <p className="auth-sub">{message}</p>
          {status !== "loading" && (
            <Link to={status === "success" ? "/login" : "/signup"} className="auth-submit">
              {status === "success" ? "Continue to sign in" : "Return to signup"}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
